import { useScrollReveal } from '../hooks/useScrollReveal';
import { useParallax } from '../hooks/useParallax';

const questions = [
  {
    num: 1,
    question: '哪里强',
    answer: '识别优势和示范经验',
    icon: 'ri-medal-line',
    color: 'primary' as const,
  },
  {
    num: 2,
    question: '哪里弱',
    answer: '定位共性短板',
    icon: 'ri-search-eye-line',
    color: 'accent' as const,
  },
  {
    num: 3,
    question: '资源投哪里',
    answer: '确定培训和资源支持方向',
    icon: 'ri-funds-line',
    color: 'primary' as const,
  },
  {
    num: 4,
    question: '经验怎么推广',
    answer: '形成案例库和教研资源',
    icon: 'ri-share-forward-line',
    color: 'accent' as const,
  },
];

export default function P76MgmtQuestions({ forceVisible = false }: { forceVisible?: boolean }) {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.12, forceVisible);
  const { ref: orb1Ref, offset: orb1Y } = useParallax(0.05);
  const { ref: orb2Ref, offset: orb2Y } = useParallax(-0.04);

  return (
    <div className="relative h-screen flex flex-col justify-center overflow-hidden bg-background-50">
      <div ref={orb1Ref} className="absolute top-20 right-24 w-80 h-80 rounded-full bg-primary-100/10 blur-[100px] pointer-events-none" style={{ transform: `translateY(${orb1Y}px)` }} />
      <div ref={orb2Ref} className="absolute bottom-28 left-12 w-96 h-96 rounded-full bg-accent-100/8 blur-[120px] pointer-events-none" style={{ transform: `translateY(${orb2Y}px)` }} />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-6 md:py-8">
        <div ref={titleRef} className="text-center mb-4 md:mb-5">
          <span className={`inline-flex items-center gap-2 text-xs font-body font-semibold text-gold-600 uppercase tracking-[0.15em] mb-4 transition-all duration-700 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <span className="gold-dot" />质量治理
          </span>
          <h2 className={`font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 transition-all duration-1000 delay-100 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            质量治理回答<span className="text-gold-600">四个核心问题</span>
          </h2>
          <p className={`text-sm text-foreground-600 font-body max-w-2xl mx-auto leading-relaxed transition-all duration-1000 delay-200 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            治理的目的不是把问题标出来，而是决定谁需要什么支持、优秀经验怎样扩散
          </p>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 max-w-6xl mx-auto mb-3 transition-all duration-1000 delay-300 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
          {questions.map((q, i) => (
            <div
              key={q.num}
              className="p-5 glass-liquid rounded-xl"
              style={{ transitionDelay: `${300 + i * 120}ms` }}
            >
              <div className="text-center">
                <div className={`w-12 h-12 mx-auto mb-4 rounded-xl ${q.color === 'accent' ? 'bg-gold-100/80 border border-gold-300/40' : 'bg-primary-100/60 border border-primary-200/40'} flex items-center justify-center`}>
                  <i className={`${q.icon} text-xl ${q.color === 'accent' ? 'text-gold-600' : 'text-primary-600'}`} />
                </div>
                <span className={`inline-block text-xs font-mono font-bold ${q.color === 'accent' ? 'text-gold-600' : 'text-primary-600'} mb-2 bg-background-100/60 px-2 py-0.5 rounded-full`}>0{q.num}</span>
                <h4 className="font-heading text-2xl font-bold text-foreground-800 mb-2">{q.question}</h4>
                <p className="text-sm text-foreground-600 font-body leading-relaxed">{q.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={`max-w-3xl mx-auto text-center transition-all duration-1000 delay-700 ${titleVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="p-5 glass-liquid rounded-xl">
            <p className="text-sm text-foreground-600 font-body leading-relaxed">
              AI评课的治理价值，就是把这些管理问题与<strong className="text-gold-700">真实课堂证据连接起来</strong>，使资源投入和教研行动有更明确的依据。跨课程后还要区分"共同问题"和"课程专属问题"。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}